module.exports = __webpack_public_path__ + "static/media/home-icon4.8ffd4490.svg";